import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {
  PyramidCategory,
  PyramidLegendItem
} from 'src/app/components/categories-pyramid-display/categories-pyramid-display.component';
import {
  OverallScoreVm,
  ScoreDevelopmentChipVm,
  ScoreDevelopmentVm,
  TeamOverviewVm
} from '../../models/team-dynamic.vm';

@Component({
  selector: 'app-overall-view',
  templateUrl: './overall-view.component.html',
  styleUrls: ['./overall-view.component.scss']
})
export class OverallViewComponent implements OnInit {
  @Input() overallScore: OverallScoreVm | null = null;
  @Input() periodLabel: string = '';
  @Input() pyramidCategories: PyramidCategory[] = [];
  @Input() pyramidLegend: PyramidLegendItem[] = [];
  @Input() scoreDevelopment: ScoreDevelopmentVm = {labels: [], values: []};
  @Input() scoreDevelopmentChips: ScoreDevelopmentChipVm[] = [];
  @Input() activeChipUuid: string | null = null;
  @Input() loadingScoreDevelopment: boolean = false;
  @Input() teamOverview: TeamOverviewVm | null = null;
  @Input() loadingTeamOverview: boolean = false;

  @Output() chipSelected = new EventEmitter<string | null>();
  @Output() categorySelected = new EventEmitter<PyramidCategory>();

  constructor() {
  }

  ngOnInit(): void {
  }

  onChipSelected(uuid: string | null) {
    this.chipSelected.emit(uuid);
  }

  onCategorySelected(category: PyramidCategory) {
    this.categorySelected.emit(category);
  }
}
